import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type ReportAccessGrantConstructor,
  ReportAccessGrant,
} from './ReportAccessGrant'

export const ReportAccessGrantConstructorFactory =
  Factory.Sync.makeFactory<ReportAccessGrantConstructor>({
    id: Factory.each(() => faker.random.number()),
    userFirstName: Factory.each(() => faker.name.firstName()),
    userLastName: Factory.each(() => faker.name.lastName()),
  })

export const ReportAccessGrantFactory = EntityFactory(
  ReportAccessGrant,
  ReportAccessGrantConstructorFactory
)
